// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"432":"74d558eb","505":"7322f429","648":"28ebc7c8"}[chunkId] + ".chunk.css";
};